/** Styl komponenty Card k tématu Erma */
export const CardStyles = {
  root: {
    background: 'var(--erma-primary-0)',
    borderRadius: 'var(--erma-border-radius-xs)',
    shadow: '0 1px 4px #0000004d, 0 1px 1px #00000024, 0 2px 1px -1px #0000001f'
  },
  body: {
    padding: '1.5rem',
    gap: '0.75rem'
  },
  caption: {
    gap: '0.5rem'
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: '500'
  }
}
